import { render, staticRenderFns } from "./RedirectModal.vue?vue&type=template&id=2cc12c04&scoped=true&"
import script from "./RedirectModal.vue?vue&type=script&lang=js&"
export * from "./RedirectModal.vue?vue&type=script&lang=js&"
import style0 from "./RedirectModal.vue?vue&type=style&index=0&id=2cc12c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc12c04",
  null
  
)

export default component.exports